module.exports = __webpack_public_path__ + "static/img/logoHH.e4087af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logoHH.png
// module id = Hzo1
// module chunks = 1